/**
 * @flow
 * @relayHash 1d51183c057ceab442a20583d0d0b93c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type TVShowOrderEditInput = {
  id: string,
  order: number,
};
export type TVShowOrderEditMutationVariables = {|
  input: TVShowOrderEditInput
|};
export type TVShowOrderEditMutationResponse = {|
  +TVShowOrderEdit: ?{|
    +tvshow: ?{|
      +id: string,
      +title: ?string,
      +order: number,
    |}
  |}
|};
export type TVShowOrderEditMutation = {|
  variables: TVShowOrderEditMutationVariables,
  response: TVShowOrderEditMutationResponse,
|};
*/


/*
mutation TVShowOrderEditMutation(
  $input: TVShowOrderEditInput!
) {
  TVShowOrderEdit(input: $input) {
    tvshow {
      id
      title
      order
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "TVShowOrderEditInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "TVShowOrderEdit",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "TVShowOrderEditInput!"
      }
    ],
    "concreteType": "TVShowEditPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "tvshow",
        "storageKey": null,
        "args": null,
        "concreteType": "TVShow",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "order",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "TVShowOrderEditMutation",
  "id": null,
  "text": "mutation TVShowOrderEditMutation(\n  $input: TVShowOrderEditInput!\n) {\n  TVShowOrderEdit(input: $input) {\n    tvshow {\n      id\n      title\n      order\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "TVShowOrderEditMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "TVShowOrderEditMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '9764899bd177b72ef31a9d709b75211b';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/TVShowOrderEditMutation.graphql.js